import { useRef } from 'react'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { Trans, useTranslation } from 'next-i18next'

import TopicSelector from '~/onboarding/components/TopicSelector'
import { mathTopicsData } from '~/shared/shared.constants'
import { AppLanguage } from '~/types/locale'
import { VideoTopic } from '~/types/bootcamp'

const SearchBar = dynamic(() => import('~/components/Search/SearchBarPickATopic'), {
  ssr: false,
})

export default function BootcampTopicsOverview({
  topicListData,
  searchToPath,
}: {
  topicListData: VideoTopic[]
  searchToPath?: boolean
}): React.ReactElement {
  const { t } = useTranslation(['onboarding', 'bootcamp'])
  const searchFieldRef = useRef(null)
  const { locale } = useRouter()
  const notEnglishLanguage = Boolean(locale) && locale !== AppLanguage.EN
  return (
    <article className="relative flex flex-col  mx-auto gap-8">
      <header className="mx-auto text-white font-bold text-center tracking-wide">
        <h1 className="text-h3 font-semibold">{t('bootcamp:bootcamps')}</h1>
        <h2 className="text-4xl mt-1 font-semibold">{t('onboarding:pickATopic')}</h2>
      </header>
      <div className="relative flex flex-col justify-center w-full py-2 max-w-screen-sm mx-auto">
        <SearchBar searchFieldRef={searchFieldRef} toPath={searchToPath} />
        {notEnglishLanguage && (
          <p className="text-white text-center pt-2 text-xs tracking-wide">
            {Trans({
              t,
              i18nKey: 'searchTip',
              components: { strong: <strong className="font-semibold" /> },
              children: t('searchTip'),
            })}
          </p>
        )}
      </div>
      <div className="flex justify-center flex-wrap gap-4">
        {topicListData.map((topicData) => {
          const topic = mathTopicsData.find((mathTopic) => mathTopic.key === topicData.key)
          if (!topic) return null
          return <TopicSelector key={topic.key} path={topicData.path} topic={topic} />
        })}
      </div>
    </article>
  )
}
